import React from "react";
import { NavLink } from "react-router-dom";

import Helmet from "react-helmet";

class SiteMap extends React.Component {

    componentDidUpdate(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }

    render() {
		const dtm_deviceCheck = /Mobile/i.test(navigator.userAgent) ? "Mobile" : "Desktop";
		const dataLayer = {
			"formName": "",
			"formStatus": "",
			"formisSubmitted": false,
			"deviceType": dtm_deviceCheck,
			"siteBusinessUnit": "Tutuwa",
			"siteErrorCode": "",
			"siteLanguage": "English",
			"siteCountry": "South Africa",
			"websiteName": "Tutuwa Foundation",
			"websiteNameCode": "TT",
			"pageCategory": "Site Map",
			"pageName": "Site Map",					
			"pageSubSection1": "Site Map",
			"pageSubSection2": "",
			"pageSubSection3": "",
			"pageSubSection4": ""
		};
        return (

            <div className="site-map">

                <Helmet>
                    <title>The Standard Bank Tutuwa Community Foundation: Site Map </title>
                    <meta name="title" content="The Standard Bank Tutuwa Community Foundation: Site Map "/>
                    <meta name="description" content="We aim to help young South Africans reach their full potential and make an active contribution to their community."/>
                    <meta name="keywords" content="Standard bank; tutuwa foundation; South African youth; investing in South Africa’s youth; social impact initiatives; economic development; investing in social impact bonds; impact investing; thought leadership; economic growth and development; industrial development; department of trade, industry and competition; youth empowerment; black economic empowerment"/>
                    <meta name="robots" content="index, follow"/>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
                    <meta name="language" content="English"/>
					<script type="text/javascript" language="javascript">{`
						var dataLayer = ${JSON.stringify(dataLayer)};
					`}</script>
					{/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-4d4e0baaa532-development.min.js" async></script> */}
					{/* <script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-0ec4707af30e-staging.min.js" async></script> */}
					<script src="https://assets.adobedtm.com/45b28ee1a4af/201532f76abd/launch-e88652abdf04.min.js" async></script> 
                </Helmet>

				<div className="content-wrapper">

					<div className="content">

						<h2>Site Map</h2>

						<p>
							<ul>

								<li>

									<NavLink
										to="/home"
									>
										Home
									</NavLink>

								</li>

								<li>

									<NavLink
										to="/about"
									>
										About Us
									</NavLink>

								</li>

								<li>

									<NavLink
										to="/programmes"
									>
										Our Programmes
									</NavLink>

								</li>

								<li>

									<NavLink
										to="/media-and-news"
									>
										Media & News
									</NavLink>

								</li>

								<li>

									<NavLink
										to="/contact"
									>
										Contact Us
									</NavLink>

								</li>

							</ul>
						</p>

					</div>

				</div>

            </div>

		);
		
	}
	
}

export default SiteMap;
